import { render, staticRenderFns } from "./CardDetail.vue?vue&type=template&id=1d79ed52"
import script from "./CardDetail.vue?vue&type=script&lang=js"
export * from "./CardDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d79ed52')) {
      api.createRecord('1d79ed52', component.options)
    } else {
      api.reload('1d79ed52', component.options)
    }
    module.hot.accept("./CardDetail.vue?vue&type=template&id=1d79ed52", function () {
      api.rerender('1d79ed52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/welfare/project/components/CardDetail.vue"
export default component.exports